import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { SecondaryTextSm, PrimaryTextSm } from 'atoms';

const template = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 44px 8px 37px;
    cursor: pointer;
    
    &:hover {
      background: ${`${theme?.colour?.primary}0D`}
    }
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: SecondaryTextSm,
      name: 'CategoryName',
      displayValue: ({ category }) => category?.name ?? ''
    },
    {
      component: PrimaryTextSm,
      name: 'CategoryScore',
      renderIf: ({ category }) => !!category?.classification,
      displayValue: ({ category }) => `${category?.classification ? Math.round(category.classification * 100) : 0}%`,
    }
  ]
})